/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { apiClient } from './client.js';

/** One recurring weekly working window (IST minute-of-day). */
export interface AvailabilityWindow {
  readonly id: string;
  readonly dayOfWeek: number;
  readonly startMinute: number;
  readonly endMinute: number;
}

export interface AvailabilitySlotPayload {
  readonly dayOfWeek: number;
  readonly startMinute: number;
  readonly endMinute: number;
}

export const availabilityApi = {
  async listMine(): Promise<readonly AvailabilityWindow[]> {
    const { data } = await apiClient.get<readonly AvailabilityWindow[]>('/availability');
    return data;
  },
  async setMine(slots: readonly AvailabilitySlotPayload[]): Promise<readonly AvailabilityWindow[]> {
    const { data } = await apiClient.put<readonly AvailabilityWindow[]>('/availability', { slots });
    return data;
  },
};
